/**
 * Se exporta datalayer
 * Se debe incrustar en el <head> como <script> antes de la librería
 * Las variables que son arrays deben reportarse vacías si no se usan
 * (por eso están comentadas,para
 * manter la estructura pero sin que se envíen)
 */
module.exports = {
  versionDL: "20190718_4.0",
  pageInstanceID: "",
  page: {
    pageInfo: {
      pageName: "",
      pageIntent: "transaccion",
      pageSegment: "general",
      sysEnv: "",
      version: process.env.VUE_APP_BBVA_VERSION || "0.0.localhost",
      channel: "online",
      language: "ES",
      geoRegion: "",
      level1: "",
      level2: "",
      level3: "",
      level4: "",
      level5: "",
      level6: "",
      level7: "",
      level8: "",
      level9: "",
      level10: "",
      area: "publica",
      server: "",
      businessUnit: "BBVA Argentina",
      siteAppName: "BBVA Argentina",
      projectName: "",
      errorPage: ""
    },
    pageActivity: {
      search: {
        onSiteSearchResults: "",
        onSiteSearchTerm: "",
        onSiteSearchEnterTerm: ""
      },
      link: {
        name: "",
        url: "",
        ext: "",
        aux1: "",
        aux2: "",
        aux3: ""
      },
      video: {
        nameOfVideoDisplayed: ""
      },
      audio: {
        nameOfPodcastDisplayed: ""
      },
      loginType: ""
    }
  },
  optimization: {
    attributes: [
      // {
      //   idOptimization: "",
      //   experience: "",
      //   place: "",
      //   type: "",
      //   executor: "",
      //   audience: ""
      // }
    ],
    event: {
      eventName: "",
      optimizationEvent: ""
    }
  },
  internalCampaign: {
    attributes: [
      // {
      //   location: "",
      //   campaignFormat: "",
      //   collectiveCode: "",
      //   campaignName: "",
      //   product: "",
      //   productCode: "",
      //   quantity: ""
      // }
    ],
    event: {
      eventInfo: {
        eventName: "",
        siteActionName: ""
      }
    }
  },
  user: {
    device: {
      userAgent: "",
      mobile: "",
      root: ""
    },
    userState: "no logado",
    profileID: "",
    userID: "",
    prospectID: "",
    segment: {
      global: "",
      profile: ""
    },
    gender: "",
    country: "",
    state: "",
    age: "",
    civilStatus: "",
    educationLevel: "",
    jobType: ""
  },
  application: {
    transactionID: "",
    application: {
      type: "formulario",
      name: ""
    },
    fulfillmentModel: "online",
    typology: "",
    programTypeHired: "",
    offer: "",
    operationNumber: "",
    process: "",
    step: "",
    interactionLevel: "",
    isQualifiedVisits: "",
    state: "",
    errorType: "",
    earnings: "",
    expenses: "",
    customFields: "",
    globalApplication: "collect retirement"
  },
  products: {
    attributes: [
      {
        primaryCategory: "",
        productSubtype: "",
        productName: "",
        productCode: "",
        quantity: "",
        amount: "",
        paymentAmount: "",
        numberOfPayments: "",
        paymentDate: "",
        paymentType: "",
        serviceCharge: "",
        currency: "",
        numberOfHolders: "",
        interestRate: {
          tin: "",
          tae: "",
          rate: ""
        },
        term: "",
        group: "",
        state: ""
      }
    ],
    productPortfolio: [
      // {
      //   productName: "",
      //   balance: "",
      //   currency: "",
      //   productCode: ""
      // }
    ]
  }
};
